<template>
<div class="empty-pane">
    <img :src="image" :alt="text" class="empty-pane__image disabled-image" />

    <div class="mt-6 text-h6 empty-pane__text">{{ text }}</div>
</div>
</template>

<script setup lang="ts">
defineProps<{
    image: string
    text: string
}>()
</script>

<style scoped>
.empty-pane {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 0;
}

.empty-pane__image {
    width: 50%;
    max-width: 100px;
    height: 100px;
}

.empty-pane__text {
    color: #666;
    font-weight: 400;
}
</style>
